{
  "settings": {
    "language": {
      "label": "Sprog",
      "help": "Flere sprog kommer snart",
      "options": {
        "en": "English",
        "da": "Dansk"
      }
    }
  }
}
